import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';

import { CommonModule } from '@angular/common';
import { FooterComponent } from '../../../Common/footer/footer.component';
import { HeaderComponent } from '../../../Common/header/header.component';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-about-us',
    templateUrl: './about-us.component.html',
    styleUrls: ['./about-us.component.scss'],
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, HttpClientModule, MatSnackBarModule, HeaderComponent, FooterComponent, ]
})
export class AboutUsComponent implements OnInit {

  @Input() backgroundImageId: string | undefined;
  @Input() loanTypeId: number | null = null;
  @Input() serviceName: string | undefined = 'Financial Plan';

  baseUrl: string = environment.baseUrl;
  backgroundImageUrl: string | undefined;
  submissionSuccess: boolean = false;
  successMessage: string = '';

  enquiryForm!: FormGroup;

  constructor(private http: HttpClient, private snackBar: MatSnackBar) {}

  ngOnInit(): void {
    this.initializeForm();
    this.setBackgroundImage();
  }

  private initializeForm(): void {
    this.enquiryForm = new FormGroup({
      full_name: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      phone: new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(8)]),
      appointment_date: new FormControl('', Validators.required),
      loan_type_id: new FormControl(this.loanTypeId ?? ''),
      organization_id: new FormControl(1),
      enq_detail_msg: new FormControl('', [Validators.required])
    });
  }

  private setBackgroundImage(): void {
    const imageMap: { [key: string]: string } = {
      '1': 'url(../../../assets/ba.jpg)',
      '2': 'url(../../../assets/rp/elderly.jpg)',
      '3': 'url(../../../assets/cp/father-teaching-sons-home.jpg)',
      '4': 'url(../../../assets/Services/childmp/child_weddding.jpg)',
      '5': 'url(../../../assets/CM/3d-family-investment-discussion-savings-profits-concept-with-candid-shot-capturing-natural-intera.jpg)',
      '6': 'url(../../../assets/HE/health-banner.jpg)',
      '7': 'url(../../../assets/TP/businessman-businesswoman-make-work-plan.jpg)',
      '8': 'url(../../../assets/er/er-banner.jpeg)'
    };
    this.backgroundImageUrl = imageMap[this.backgroundImageId ?? '8'];
  }

  onSubmit(): void {
    if (this.enquiryForm.valid) {
      const formData = { ...this.enquiryForm.value };
      this.submitEnquiry(formData);
    }
  }

  private submitEnquiry(formData: any): void {
    this.http.post(`${this.baseUrl}/add_basic_enquiry`, formData).subscribe({
      next: (res: any) => {
        this.handleSuccess(res);
      },
      error: (error: any) => {
        this.handleError(error);
      }
    });
  }

  private handleSuccess(res: any): void {
    if (res.success) {
      this.successMessage = 'Thank you for your enquiry! We will get back to you shortly.';
      this.submissionSuccess = true;
      this.enquiryForm.reset();
      this.showSnackbar('Enquiry submitted successfully!', 'success-snackbar');
    } else {
      this.showSnackbar('Submission failed. Please try again.', 'error-snackbar');
    }
  }

  private handleError(error: any): void {
    console.error('Error during submission:', error);
    this.showSnackbar('Error occurred during submission. Please try again.', 'error-snackbar');
  }

  private showSnackbar(message: string, panelClass: string): void {
    this.snackBar.open(message, 'Close', {
      duration: 3000,
      verticalPosition: 'top',
      horizontalPosition: 'center',
      panelClass: [panelClass]
    });
  }
}
